import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueFire, VueFireAuthOptionsFromAuth } from 'vuefire';
import { auth, firebaseApp } from './lib/firebase';
import { registerDeepLinks } from './lib/deeplinks';
import { router } from './router';
import App from './App.vue';
import './styles/index.css';

registerDeepLinks();

createApp(App)
  .use(createPinia())
  .use(VueFire, { firebaseApp, modules: [VueFireAuthOptionsFromAuth({ auth })] })
  .use(router)
  .mount('#root');
